import { Button, Form } from "rsuite";
import {
  LoginFormType,
  LoginFormSchema,
  LoginDefaultValues,
} from "../../models/forms/loginForm";
import { useState } from "react";
import { LoginForm } from "./loginForm.component";
import { AppRoutesUI } from "../../config/appRoutes";
import { Link, useNavigate } from "react-router-dom";
import { ApiAuth } from "../../core/apis/auth";
import { useAppDispatch } from "../../core/redux/reduxStore";
import { AuthActions } from "../../core/redux";
import { AnyAction } from "redux";
import { StorageAuth } from "../../core/localStorage/StorageAuth";
import { showErrorToast, showSuccessToast } from "../generic/toast.component";
import { ActionMenuByRole } from "../../core/redux/slices/sliceMenuByRole";

export const Login = () => {
  const [formValue, setFormValue] = useState<LoginFormType>(LoginDefaultValues);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleSave = async (checked: boolean) => {
    if (!checked) return;
    setIsLoading(true);
    try {
      const response = await ApiAuth.login(
        formValue.userId || "",
        formValue.password || ""
      );
      if (!!response?.data?.Token) {
        const authData = response.data;
        StorageAuth.Token = authData?.Token;
        StorageAuth.Email = authData?.Email;
        StorageAuth.UserName = authData?.UserName;
        StorageAuth.User = authData;
        const userRole = authData?.Role;
        StorageAuth.Role = userRole;
        const reduxActions: AnyAction[] = [];
        if (authData?.UserName)
          reduxActions.push(AuthActions.SetUserName(authData?.UserName));

        reduxActions.push(AuthActions.SetEmail(authData?.Email));

        if (userRole) {
          reduxActions.push(AuthActions.SetUserRole(userRole));
        }

        reduxActions.push(
          ActionMenuByRole.SetMenuItems({ roles: authData.Role })
        );

        reduxActions.forEach(dispatch);
        dispatch(AuthActions.login());
        if (userRole === "User") {
          navigate(AppRoutesUI.Users.UsersProfileView());
        } else navigate(AppRoutesUI.SuperAdmin.SuperAdminCreate());
        showSuccessToast("Login Successful!");
      }
    } catch (e: any) {
      showErrorToast(e.response?.data?.Message || e.message);
    }
    setFormValue(LoginDefaultValues);
    setIsLoading(false);
  };

  return (
    <div className="d-flex flex-column px-xl-5 m-xl-4 px-sm-0">
      <Form
        formValue={formValue}
        onChange={setFormValue}
        model={LoginFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <LoginForm />
        <div className="d-flex justify-content-end align-items-center mb-3 mt-3">
          <Button
            size="sm"
            appearance="primary"
            type="submit"
            loading={isLoading}
            className="form-buttons fw-bold px-3"
          >
            Login
          </Button>
        </div>
      </Form>
      <div className="d-flex justify-content-end">
        <Link to={AppRoutesUI.Auth.ForgetPassword.Path()}>
          <p className="form-link-text">Forgot Password?</p>
        </Link>
      </div>
    </div>
  );
};
